export const pageMarginL = 20;
export const pageMarginT = 40;
export const pageMarginR = 20;
export const pageMarginB = 60;
export const pageMargins = [pageMarginL, pageMarginT, pageMarginR, pageMarginB];

export const colors = {
  lightGray: '#f8f8f8',
  lightSilver: '#d8d8d8',
}
